import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

export const useLegacyPageAsPopupCloseSubscription = () => {
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();

    useEffect(() => {
        dispatcher.listen('pageInPopup:closed', navigateToPopupBackgroundPage);

        return () => {
            dispatcher.removeListener('pageInPopup:closed', navigateToPopupBackgroundPage);
        };
    }, [navigateToPopupBackgroundPage]);
};
